const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/student`;

export const getStudentTeacher = async (userId) => {
  try {
    const response = await fetch(`${BASE_URL}/get-teacher?userId=${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Error occured while trying to get teacher from server.");
    }

    const data = await response.json();
    if (data.teacher) {
      const { teacherName, teacherEmail, teacherId } = data.teacher;
      return {
        teacherName,
        teacherEmail,
        teacherId,
      };
    } else {
      console.error("Teacher data not found in response.");
      return null;
    }
  } catch (error) {
    console.error("error: ", error);
  }
};

export const fetchTeacherAvailableTime = async (teacherId) => {
  try {
    const response = await fetch(
      `${BASE_URL}/get-teacher-available-time?teacherId=${teacherId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.warn("error while trying to get teacher available time");
      return {};
    }
  } catch (error) {
    console.error("error while trying to fetch teacher available time");
  }
};

export const fetchAppointMeeting = async (eventData) => {
  try {
    const response = await fetch(`${BASE_URL}/appoint-meeting`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(eventData),
    });
    if (response.ok) {
      return response;
    } else {
      console.warn("Error while trying to book a meeting");
    }
  } catch (error) {
    console.error("Error while trying to book a meeting");
  }
};
